export default __webpack_public_path__ + "static/media/civic health-01 1.3bbb76f4.png";